import NavBarCtrl from 'plugin?nav-bar-controller!portal/directives/NavBarBaseCtrl';

export default () => {
    return {
        restrict: 'EA',
        controller: NavBarCtrl
    };
};